import * as properties from './metadataProperties';

export const PREFERRED_ORDER = [
  properties.CREATE_DATE,
  properties.MODIFY_DATE,
  properties.DATE,
  properties.DATETIME_ORIGINAL,
  properties.CREATOR,
  properties.PRODUCER,
  properties.AUTHOR,
  properties.TITLE,
  properties.SOFTWARE,
  properties.WRITER_NAME,
  properties.CREATOR_TOOL,
  properties.XMP_TOOL_KIT,
  properties.HISTORY_WHEN,
  properties.HISTORY_ACTION,
  properties.HISTORY_SOFTWARE_AGENT,
  properties.HISTORY,
  properties.READER_NAME,
  properties.ANOMALY,
];

export const ANOMALY = [properties.ANOMALY];

export const DATES = [
  properties.CREATE_DATE,
  properties.MODIFY_DATE,
  properties.DATE,
];

export const SOFTWARE = [
  properties.CREATOR_TOOL,
  properties.PRODUCER,
  properties.CREATOR,
  properties.SOFTWARE,
  properties.WRITER_NAME,
  properties.AUTHOR,
];

export const TEXT_LAYER_TEXT_GROUP = [properties.TEXT_LAYER_TEXT];

export const GROUPS = {
  dates: DATES,
  software: SOFTWARE,
};

export const metadataConfig = {
  [properties.TEXT_LAYER_TEXT]: {
    title: 'Added text',
  },
};
